import { _request } from './api';

export const listMatches = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const addMatch = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match',
      method: 'POST',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const addMatchRoster = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/roster',
      method: 'POST',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const itemMatch = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/item',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const listMatchRoster = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/roster',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const itemMatchRosterCounts = matchesGuid => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/${matchesGuid}/roster-counts`,
      method: 'GET'
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const itemMatchReport = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/report',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const saveMatchReport = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/report',
      method: 'POST',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const editMatch = (matchesGuid, params) => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/${matchesGuid}`,
      method: 'PUT',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const patchMatchActive = (matchesGuid, params) => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/${matchesGuid}/active`,
      method: 'PATCH',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const removeMatch = matchesGuid => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/${matchesGuid}`,
      method: 'DELETE'
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const listCompetitionRounds = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/competition-rounds',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const addCompetitionRound = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/competition-rounds',
      method: 'POST',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const listRoundTypes = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/round-types',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const itemCompetitionRound = params => {
  return new Promise((resolve, reject) => {
    return _request({
      target: 'match/competition-rounds/item',
      method: 'GET',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const editCompetitionRound = (competitionRoundGuid, params) => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/competition-rounds/${competitionRoundGuid}`,
      method: 'PUT',
      params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const removeCompetitionRound = competitionRoundGuid => {
  return new Promise((resolve, reject) => {
    return _request({
      target: `match/competition-rounds/${competitionRoundGuid}`,
      method: 'DELETE'
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};
